/**
 * Local ki.js extensions created by Tarjei
 * NB! Depends on utils for closest
 */

$.prototype.parent = function() {
  if (this.length !== 1) {
    console.error('parent expects length of 1.', this)
    throw new Error('parent expects length of 1.')
  }
  var ret
  this.each(function(e) {
    ret = e.parentElement
  })
  return $(ret)
}
$.prototype.parents = function(selector) {
  var res = []
  this.each(function(element) {
    res.push(closest(element, selector))
  })
  return $(res)
}

$.prototype.find = function(selector) {
  var res = []
  this.each(function(element) {
    if (!element) {
      return
    }
    res = res.concat(domListToArray(element.querySelectorAll(selector)))
  })
  return $(res)
}
$.prototype.offsetTop = function() {
  if (this.length === 0) {
    return 0
  }
  return this.first()[0].offsetTop
}

function domListToArray(nl) {
  var arr = []
  for (var i = 0, n; (n = nl[i]); ++i) {
    arr.push(n)
  }
  return arr
}

$.prototype.height = function() {
  var B = document.body
  var H = document.documentElement
  var height

  if (typeof document.height !== 'undefined') {
    height = document.height // For webkit browsers
  } else {
    height = Math.max(
      B.scrollHeight,
      B.offsetHeight,
      H.clientHeight,
      H.scrollHeight,
      H.offsetHeight
    )
  }
  return height
}
